import { PuiButtonGroupComponent } from './button/button.component';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// 3rd party
import { FileUploadModule } from 'ng2-file-upload';
// dialog
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MdDialogModule, MdInputModule, MdButtonModule } from '@angular/material';

import { PuiButtonComponent, PuiButtonDropDownDirective } from './button/index';
import { PuiCheckboxGroupComponent, PuiCheckboxComponent } from './checkbox/index';
import { PuiColumnComponent, PuiPageComponent, PuiRowComponent } from './structure/index';
import { PuiFormComponent, PuiFormBodyComponent, PuiFormCommandComponent,
  PuiFormMessageComponent } from './form/index';
import { PuiInputComponent } from './input/index';
import { PuiListComponent, PuiListItemComponent } from './list/index';
import { PuiMenuComponent, PuiMenuItemComponent, PuiItemGroupComponent,
  PuiMenuMainComponent, PuiMenuProfileComponent } from './menu/index';
import { PuiNavComponent, PuiNavItemComponent } from './nav/index';
import { PuiPortletComponent, PuiPortletBodyComponent, PuiPortletHeaderComponent,
  PuiPortletActionComponent, PuiPortletToolComponent } from './portlet/index';
import { PuiSelectComponent } from './select/index';
import { PuiTabComponent, PuiTabsComponent } from './tab/index';
import { PuiToggleDirective } from './toggle/index';
import { PuiDateRangeComponent } from './daterange/index';
import { PuiRadioGroupComponent, PuiRadioComponent } from './radio/index';
import { PuiDateComponent } from './date/index';
import { PuiFileComponent } from './file/index';
import { PuiTemplateDirective } from './common/shared';
import { PuiLabelComponent } from './label/index';
import { PuiTooltipDirective } from './tooltip/index';

// dialog
import {
  PuiDialogComponent, PuiDialogTitleDirective, PuiDialogContentDirective, PuiDialogActionsDirective,
  PuiAlertDialogComponent, PuiConfirmDialogComponent, PuiPromptDialogComponent,
  DIALOG_PROVIDER } from './dialog/index';
// message
import { PuiMessageComponent } from './message/index';


const ELEMENTS_COMPONENTS = [
  PuiButtonComponent, PuiButtonGroupComponent, PuiButtonDropDownDirective,
  PuiCheckboxGroupComponent, PuiCheckboxComponent,
  PuiColumnComponent, PuiPageComponent, PuiRowComponent,
  PuiFileComponent,
  PuiFormComponent, PuiFormBodyComponent, PuiFormCommandComponent, PuiFormMessageComponent,
  PuiInputComponent,
  PuiDateComponent,
  PuiDateRangeComponent,
  PuiLabelComponent,
  PuiListComponent, PuiListItemComponent,
  PuiMenuComponent, PuiMenuItemComponent, PuiItemGroupComponent, PuiMenuMainComponent, PuiMenuProfileComponent,
  PuiNavComponent, PuiNavItemComponent,
  PuiPortletComponent, PuiPortletBodyComponent, PuiPortletHeaderComponent, PuiPortletActionComponent, PuiPortletToolComponent,
  PuiRadioGroupComponent, PuiRadioComponent,
  PuiSelectComponent,
  PuiTabComponent, PuiTabsComponent,
  PuiTemplateDirective,
  PuiToggleDirective,
  PuiTooltipDirective,
  // dialog
  PuiDialogComponent, PuiAlertDialogComponent, PuiConfirmDialogComponent, PuiPromptDialogComponent,
  PuiDialogTitleDirective, PuiDialogContentDirective, PuiDialogActionsDirective,
  // message
  PuiMessageComponent
];

const ELEMENTS_ENTRY_COMPONENTS = [
  PuiAlertDialogComponent,
  PuiConfirmDialogComponent,
  PuiPromptDialogComponent
];

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    FileUploadModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MdDialogModule, MdInputModule, MdButtonModule
  ],
  exports: ELEMENTS_COMPONENTS,
  declarations: ELEMENTS_COMPONENTS,
  entryComponents: [ ELEMENTS_ENTRY_COMPONENTS ],
  providers: [ DIALOG_PROVIDER ]
})
export class PuiElementsModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: PuiElementsModule, providers: [] };
  }
}
